export var defaultConfig = {
  isPreview: false,
  previewRefetchInterval: 1000,
  netlifyUrl: "https://www.paraplegie.ch",
  raisenowWidget: {
    test: "1",
    accountUuid: "",
    engagementUrl: ""
  },
  google: {
    gtm_code: "GTM-KQGSR6H",
    maps_key: "AIzaSyB4g8uBtpeYePBJGAlJCuKQnTRK9uIbrvI"
  },
  activeCampaign: {
    enabled: false
  },
  drupalUrl: "http://127.0.0.1:8888",
  drupalBackendUrl: "http://127.0.0.1:8888",
  donatePagePath: {
    en: "/en/support-us/donations",
    de: "/de/uns-unterstuetzen/spenden",
    fr: "/fr/nous-soutenir/faire-un-don",
    it: "/it/come-sostenerci/donazioni"
  },
  memberPagePath: {
    en: "/en/support-us/become-member",
    de: "/de/uns-unterstuetzen/mitglied-werden",
    fr: "/fr/nous-soutenir/devenir-membre",
    it: "/it/sosteneteci/diventare-membro"
  },
  groupPagePath: {
    en: "/en/about-us/organisation/overview-swiss-paraplegic-group",
    de: "/de/ueber-uns/organisation/organisationen-schweizer-paraplegiker-gruppe",
    fr: "/fr/portrait/organisation/apercu-groupe-suisse-pour-paraplegiques",
    it: "/it/chi-siamo/organizzazione/panoramica-gruppo-svizzero-paraplegici"
  },
  memberServicePagePath: {
    en: "/en/member-service",
    de: "/de/goenner-services",
    fr: "/fr/service-bienfaiteurs",
    it: "/it/servizio-sostenitori"
  },
  orthotecPagePath: {
    en: "/orthotec/de",
    de: "/orthotec/de",
    fr: "/orthotec/fr",
    it: "/orthotec/it"
  }
};
var config;
export function appConfig() {
  if (!config) {
    throw "App config not initialized.";
  }
  return config;
}
export function initAppConfig(appConfig) {
  config = appConfig;
}